import script from "./PermissionGroups.vue?vue&type=script&setup=true&lang=js"
export * from "./PermissionGroups.vue?vue&type=script&setup=true&lang=js"

import "./PermissionGroups.vue?vue&type=style&index=0&id=855a9272&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-855a9272"]])

export default __exports__